import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { BranchListContextImport } from "../../../../provider/branch/branch_list/BranchListContextProvider";

const BranchListActions = () => {
  const { showSearch, updateShowSearch } = BranchListContextImport();
  return (
    <>
      {!showSearch && (
        <IconNormal
          name="magnify"
          color={AppTheme.themeFont}
          handleClick={() => updateShowSearch()}
        />
      )}
    </>
  );
};

export default BranchListActions;
